import { useTranslation } from '@framework/i18n';
import clx from 'classnames';
import styled from 'styled-components';
import {
  ISubmissionMenuItem,
  SubmissionMenuItemType,
} from './ISubmissionMenuItem';

const ModuleMenuTitle = styled.div`
  overflow: unset;
  white-space: unset;
  text-overflow: unset;
  font-weight: 600;
  padding-top: 2px;
  white-space: normal;
  &.is-section {
    font-weight: 400;
  }
`;

export interface ISubmissionMenuLabelProps {
  item: ISubmissionMenuItem;
}

export function SubmissionMenuLabel(props: ISubmissionMenuLabelProps) {
  const { t } = useTranslation();

  if (!props.item) return null;
  const isSection =
    props.item.type === SubmissionMenuItemType.Section ||
    props.item.type === SubmissionMenuItemType.Guide;

  return (
    <ModuleMenuTitle
      aria-label={
        props.item.type === SubmissionMenuItemType.Section
          ? `${t('submission-menu-label.aria-label.name-prefix', 'sezione')}: ${
              props.item.name
            }`
          : undefined
      }
      className={clx({ 'is-section': isSection })}
    >
      {props.item.name}
    </ModuleMenuTitle>
  );
}
